export default "__VITE_ASSET__91bf784d__"